import React from 'react';
import Link from './Link';
import fn from '../../helpers/fn';

const MailLink = Link.withComponent(({ className, email, children }) => (
  <a
    className={className}
    href={`mailto:${email}`}
  >{children}</a>
));

export default fn(__filename, MailLink);



// WEBPACK FOOTER //
// ./src/components/links/MailLink.js